import { render } from "./Dashboard.vue?vue&type=template&id=11c62e6b&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=11c62e6b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11c62e6b"

export default script